import Card from '@commons/components/Card';
import DrupalImage from '@commons/components/Image/Drupal';
import LoadingSkeleton from '@commons/components/LoadingSkeleton';
import RichText from '@commons/components/RichText';
import Separator from '@commons/components/Separator';
import Flex from '@commons/containers/Flex';
import { Link } from '@commons/i18n/navigation';
import { CARD_DISPLAY_IMAGE_SIZES } from '@commons/pagebuilder/nodes/images';

import type { MemberNodeProps } from '.';
import styles from './Card.module.scss';

/**
 * Member node card component.
 */

export const MemberNodeCard = ({ alias, title, headshot, position }: MemberNodeProps) => (
  <Link href={alias || '#'} scroll={false}>
    <Card hasBorder justify="start" direction={{ xs: 'row', md: 'column' }} className={styles.card}>
      <Card.Overlay>
        <DrupalImage {...headshot} className={styles.headshot} sizes={CARD_DISPLAY_IMAGE_SIZES} />
      </Card.Overlay>
      <Flex
        gap="xs"
        width={12}
        align="start"
        direction="column"
        justify="space-between"
        className="h-100"
      >
        <Separator dash color="primary" />
        <Flex.Item>
          <Card.Title transform="uppercase">{title}</Card.Title>
          <RichText value={position} />
        </Flex.Item>
      </Flex>
    </Card>
  </Link>
);

/**
 * Loading member node card component.
 */

export const LoadingMemberNodeCard = () => (
  <Card hasBorder direction={{ xs: 'row', lg: 'column' }} className={styles.card}>
    <LoadingSkeleton className={styles.headshot} />
    <Flex gap="xs" width={12} direction="column">
      <Separator dash color="primary" />
      <LoadingSkeleton width="80%" />
      <LoadingSkeleton width="60%" />
    </Flex>
  </Card>
);

export default MemberNodeCard;
